var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowInComingClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "282px",
    viewBox: "0 0 95 282",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4F4E\u538B\u8FDB\u7EBF\u56DE\u8DEF-\u95ED\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-237.000000, -1145.000000)",
    id: "\\u4F4E\\u538B\\u8FDB\\u7EBF\\u56DE\\u8DEF-\\u95ED\\u5408"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.000000, 1145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-41\\u5907\\u4EFD-2",
    transform: "translate(46.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-7",
    transform: "translate(0.000000, 32.000000)",
    stroke: "#E64242",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 10.5,
    id: "\\u76F4\\u7EBF-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    id: "\\u76F4\\u7EBF-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 14.5,
    x2: 10.5,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 17.5,
    x2: 8.5,
    y2: 17.5,
    id: "\\u76F4\\u7EBF-6\\u5907\\u4EFD-2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    stroke: "#E64242",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 11,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(4.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 0.5,
    x2: 2,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-9",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "#E64242",
    points: "0 7 4 7 2 14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    transform: "translate(0.000000, 208.500000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 29.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 4.5,
    x2: 37,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 4.5,
    x2: 40,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 8.5,
    x2: 43.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-3",
    cx: 52.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.5,
    y1: 3.05311332e-16,
    x2: 52.5,
    y2: 17,
    id: "\\u76F4\\u7EBF-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 4.5,
    x2: 60,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 4.5,
    x2: 63,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.5,
    y1: 8.5,
    x2: 66.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-4",
    cx: 6.5,
    cy: 8.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 4.5,
    x2: 14,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 4.5,
    x2: 17,
    y2: 12.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 8.5,
    x2: 20.5,
    y2: 8.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 3.05311332e-16,
    x2: 6.5,
    y2: 17,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-6",
    cx: 6.5,
    cy: 29.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 25.5,
    x2: 14,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 25.5,
    x2: 17,
    y2: 33.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 29.5,
    x2: 20.5,
    y2: 29.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 21,
    x2: 6.5,
    y2: 38,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-6",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94,33 L94,281 L29.5,281 L29.5,192.5 M29.5,134.5 L29.5,40 C23.8333333,39.3333333 21,36.6666667 21,32 C21,27.3333333 23.8333333,24.6666667 29.5,24 L29.5,17",
    id: "\\u5F62\\u72B6",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(27.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 0.5,
    x2: 2,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-9",
    stroke: "#E64242",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "#E64242",
    points: "0 7 4 7 2 14"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u76F4\\u7EBF-8\\u5907\\u4EFD-5",
    stroke: "#E64242",
    strokeWidth: 2,
    strokeLinecap: "square",
    points: "52.5 69 52.5 53 29.5 53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14\\u5907\\u4EFD-19",
    transform: "translate(23.000000, 134.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0.5,
    x2: 6.5,
    y2: 16.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 41.5,
    x2: 6.5,
    y2: 57.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-2",
    points: "13 14 6.5 8 4.14945855e-15 14"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FF4D4F",
    x: 2,
    y: 17,
    width: 9,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(0.000000, 44.000000)",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-3",
    transform: "translate(6.500000, 3.000000) scale(1, -1) translate(-6.500000, -3.000000) ",
    points: "13 6 6.5 0 4.14945855e-15 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84\\u5907\\u4EFD-4",
    transform: "translate(6.500000, 11.000000) scale(1, -1) translate(-6.500000, -11.000000) ",
    points: "13 14 6.5 8 4.14945855e-15 14"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowInComingClose);
export default __webpack_public_path__ + "static/media/low_inComing_close.895d89d85aab784f6db020d01cf20b8d.svg";
export { ForwardRef as ReactComponent };